export const NAMESPACE = 'IDS_CONVERTER/GROUPS/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
